var pagination = {
	backwardText: "önceki sayfa",
	forwardText: "sonraki sayfa",
	pageRangeText: "{total} sayfadan {current} tanesi",
	itemsPerPageText: "Sayfa başına öğe",
	itemRangeText: "{total} sayfadan {start}-{end} tanesi",
	pageNumberText: "mevcut sayfa"
};
var searchPlaceholder = "Ara...";
var trTranslations = {
	pagination: pagination,
	searchPlaceholder: searchPlaceholder
};

export { trTranslations as default, pagination, searchPlaceholder };
